import { Component, inject, Input, OnInit } from "@angular/core";
import { IHeaderExtensionData, PrimaryArea } from "@geolib/geoappbase-client";
import { UIRouterGlobals } from "@uirouter/angular";


@Component({
    templateUrl: "./header-info.component.html",
    selector: "geobus-header-info",
    styleUrls: ["./header-info.component.scss"],
})
export class HeaderInfoComponent implements OnInit {

    @Input() public extensionData: IHeaderExtensionData;

    private readonly uiRouterGlobals = inject(UIRouterGlobals);

    public constructor(
        private readonly primaryArea: PrimaryArea,
    ) {
    }

    public ngOnInit(): void {
        this.primaryArea.getPrimaryAreaData(this.uiRouterGlobals.params.primaryArea as string).subscribe((primaryAreaData) => {
            this.extensionData = {
                primaryArea: this.uiRouterGlobals.params.primaryArea,
                primaryAreaName: primaryAreaData.label,
                primaryAreaSubTitle: primaryAreaData.subLabel,
            };
        });
    }

}
